export default "__VITE_ASSET__D5oezR2V__"